<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">
      <div>
        <HomeComponent/>
      </div>
    </transition>
  </div>
</template>

<style lang="scss">
@import "../styles/main.scss";
</style>

<script>
    import HomeComponent from '@/components/HomeComponent.vue'


export default {
  name: 'Home',
  props: {
  },
  components: {
      HomeComponent,
  },
  data() {
    return {
    };
  }
};
</script>
